import Dialog from '@mui/material/Dialog'

import { Icon } from '../../../../../components/UI'
import ProfilePublicViewUser from './ProfilePublicViewUser'
import ProfilePublicViewRate from './ProfilePublicViewRate'
import ProfilePublicViewClasses from './ProfilePublicViewClasses'
import ProfilePublicViewReviews from './ProfilePublicViewReviews'

const ProfilePublicView = ({ open, onClose }) => {
  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[800px] !p-[32px] !rounded-[10px] !bg-[#FEEBDD] !shadow-modal',
      }}
    >
      <div className="w-full flex items-center justify-center flex-col">
        <button className="flex items-center" onClick={handleClose}>
          <Icon name="arrow-left-line" color="#F67443" className="w-[24px] h-[24px]" />

          <span className="ml-[12px] text-sm font-normal text-primary-100">Back</span>
        </button>

        <ProfilePublicViewUser />

        <div className="w-full flex mt-[10px] gap-x-[10px]">
          <ProfilePublicViewRate />
          <ProfilePublicViewClasses />
        </div>

        <ProfilePublicViewReviews />
      </div>
    </Dialog>
  )
}

export default ProfilePublicView
